import { Colors } from '@blueprintjs/core';

const COLORS = ['#1F4B99', '#578FA1', '#BACBA1', '#F2BE75', '#CD7534', '#9E2B0E'];
export default COLORS;

export const NO_VALUE_COLOR = Colors.GRAY1;
export const LINE_COLOR = Colors.WHITE;
